import { render, staticRenderFns } from "./ThankYouHeader.vue?vue&type=template&id=40c773b3"
import script from "./ThankYouHeader.vue?vue&type=script&lang=js"
export * from "./ThankYouHeader.vue?vue&type=script&lang=js"
import style0 from "./ThankYouHeader.vue?vue&type=style&index=0&id=40c773b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports